import styled from 'styled-components'
import { StopType } from './TransportStopsTable.types'

export const StopsTable = styled.div`
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 8px;
  overflow: hidden;
`

export const StopRow = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr auto auto;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: background 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
  }
`

export const StopIcon = styled.div<{ $type: StopType }>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;

  ${({ $type, theme }) => {
    const configs = {
      bus: { bg: '#f59e0b15', color: '#f59e0b' },
      tram: { bg: '#3b82f615', color: '#3b82f6' },
      train: { bg: '#ef444415', color: '#ef4444' },
    }
    const config = configs[$type]
    return `
      background: ${config.bg};
      color: ${config.color};
    `
  }}
`

export const StopName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const StopDistance = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
`
